import React from 'react';
import {  Box } from '@chakra-ui/react';


function ReportesContent () {
    return (
        <div>
            <Box flex="1" bg="white"></Box>
        </div>
    )
  };


export default ReportesContent;